import React from "react";
import "./Secondhero.scss";
import kiriatas from "../../assets/about/3.webp";
import kiribawah from "../../assets/about/5.webp";
import kananatas from "../../assets/about/4.webp";
import kananbawah from "../../assets/about/6.webp";
import { BsChatRightHeartFill } from "react-icons/bs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const SecondHero = () => {
  const waabout = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send?phone=62895417144022&text=Halo%20Sandy,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20()%20(https://marketing-grandwisatabekasi.com/)%20?&fbclid=PAAaa7g9IJ-tB3RyMunLD6w_5ysqP4oI6PA2d9Ml7Isc1_OXjeOiGuAqu7Ap0";
    window.location.href = whatsappLink;
  };
  return (
    <div className="secondherocontainer">
      <div className="secondmiddle">
        <div className="rightcontent">
          <div className="leftpicture">
            <div className="kiriatas">
              <img src={kiriatas} className="satu" alt="Nava" />
            </div>
            <div className="kiribawah">
              <img src={kiribawah} className="dua" alt="Nava" />
            </div>
          </div>
          <div className="rightpicture">
            <div className="kananatas">
              <img src={kananatas} className="tiga" alt="Nava" />
            </div>
            <div className="kananbawah">
              <img src={kananbawah} className="empat" alt="Nava" />
            </div>
          </div>
        </div>
        <div className="content">
          <div id="about" className="header1">
            About Us
          </div>
          <div className="desk">
            Grand Wisata Bekasi adalah area perumahan dan komersial di Tambun,
            Kabupaten Bekasi, Jawa Barat. Rumah di Grand Wisata Bekasi memiliki
            fasilitas lengkap, mulai dari perabot lengkap hingga peralatan
            elektronik gratis.
          </div>
          <div className="header2">Facility in Area</div>
          <div className="listkawasan">
            <div className="list1">
              <ul>
                <li>
                  <BsChatRightHeartFill color="#1C244B" /> &nbsp;Akses Pintu Tol
                  dalam Kawasan
                </li>
                <li>
                  <BsChatRightHeartFill color="#1C244B" /> &nbsp;Mall Living
                  World
                </li>
                <li>
                  <BsChatRightHeartFill color="#1C244B" /> &nbsp;Water Park Go!
                  Wet
                </li>
                <li>
                  <BsChatRightHeartFill color="#1C244B" /> &nbsp;RS Hermina
                  Grand Wisata
                </li>
                <li>
                  <BsChatRightHeartFill color="#1C244B" /> &nbsp;RS Mitra
                  Keluarga
                </li>
              </ul>
            </div>
            <div className="list2">
              <ul>
                <li>
                  <BsChatRightHeartFill color="#1C244B" /> &nbsp;IPEKA Grand
                  Wisata
                </li>
                <li>
                  <BsChatRightHeartFill color="#1C244B" /> &nbsp;Al-Azhar Grand
                  Wisata
                </li>
                <li>
                  <BsChatRightHeartFill color="#1C244B" /> &nbsp;Stasiun LRT
                </li>
                <li>
                  <BsChatRightHeartFill color="#1C244B" /> &nbsp;Stasiun KRL
                </li>
                <li>
                  <BsChatRightHeartFill color="#1C244B" /> &nbsp;RS Eka Hospital
                </li>
              </ul>
            </div>
          </div>
          <div className="button">
            <button onClick={waabout} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Hubungi Kami
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecondHero;
